export default __webpack_public_path__ + "static/media/washingDetergent.df536a24.jpeg";